import { render, staticRenderFns } from "./ExpressQuotation.vue?vue&type=template&id=bc3eb668&"
import script from "./ExpressQuotation.vue?vue&type=script&lang=js&"
export * from "./ExpressQuotation.vue?vue&type=script&lang=js&"
import style0 from "./ExpressQuotation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports